import React from 'react';
import { Users2Icon, BarChart3Icon, ClipboardCheckIcon, ZapIcon, MessagesSquareIcon, PieChartIcon } from 'lucide-react';
export const FeaturesSection = () => {
  const features = [{
    icon: <Users2Icon className="h-8 w-8 text-blue-500" data-id="element-52" />,
    title: 'High-Volume Candidate Management',
    description: 'Handle hundreds of applicants with ease using our intelligent sorting and filtering system designed for sales recruiters.'
  }, {
    icon: <BarChart3Icon className="h-8 w-8 text-blue-500" data-id="element-53" />,
    title: 'Sales Aptitude Assessment',
    description: 'Proprietary assessment tools that evaluate candidates specifically on sales abilities and potential.'
  }, {
    icon: <ClipboardCheckIcon className="h-8 w-8 text-blue-500" data-id="element-54" />,
    title: 'Automated Screening',
    description: 'AI-powered initial screening saves hours by automatically evaluating resumes against your sales role requirements.'
  }, {
    icon: <ZapIcon className="h-8 w-8 text-blue-500" data-id="element-55" />,
    title: 'Accelerated Hiring',
    description: 'Streamlined workflows designed to reduce time-to-hire for critical sales positions by up to 40%.'
  }, {
    icon: <MessagesSquareIcon className="h-8 w-8 text-blue-500" data-id="element-56" />,
    title: 'Collaborative Hiring',
    description: 'Easily involve sales managers and team leads in the hiring process with intuitive collaboration tools.'
  }, {
    icon: <PieChartIcon className="h-8 w-8 text-blue-500" data-id="element-57" />,
    title: 'Performance Analytics',
    description: 'Track hiring metrics specific to sales roles and correlate them with on-the-job performance.'
  }];
  return <section id="features" className="py-16 md:py-24 bg-white" data-id="element-58">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-59">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-61">
            Purpose-built for sales recruiting
          </h2>
          <p className="text-xl text-gray-600" data-id="element-62">
            ApplicantPass combines powerful ATS functionality with specialized
            tools for identifying and hiring top sales talent.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-63">
          {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-64">
              <div className="mb-4" data-id="element-65">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-66">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-67">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};